import { HashLink as Link } from "react-router-hash-link";
import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import { Paper } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function IndivRows(props) {
  const classes = useStyles();
  let rank = 1;
  for (let i = 0; i < props.rows.length; i++) {
    props.rows[i].rank = rank;
    if (i < props.rows.length-1 && props.rows[i].pp20 !== props.rows[i+1].pp20) {
      rank++;
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow style={{backgroundColor: "#efefef"}}>
            <TableCell><b>Rank</b></TableCell>
            <TableCell><b>Player</b></TableCell>
            <TableCell><b>Team</b></TableCell>
            <TableCell align="right"><b>GP</b></TableCell>
            <TableCell align="right"><b>15</b></TableCell>
            <TableCell align="right"><b>10</b></TableCell>
            <TableCell align="right"><b>-5</b></TableCell>
            <TableCell align="right"><b>P/N</b></TableCell>
            <TableCell align="right"><b>G/N</b></TableCell>
            <TableCell align="right"><b>TUH</b></TableCell>
            <TableCell align="right"><b>PPTUH</b></TableCell>
            <TableCell align="right"><b>PTS</b></TableCell>
            <TableCell align="right"><b>PP20</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell>{row.rank}</TableCell>
              <TableCell component="th" scope="row">
                <Link className="about" to={`/results/individualdetail#${row.id}`}>{row.name}</Link>
              </TableCell>
              <TableCell>
                <Link className="about" to={`/results/teamdetail#${row.teamid}`}>{row.team}</Link>
              </TableCell>
              <TableCell align="right">{row.gp}</TableCell>
              <TableCell align="right">{row.power}</TableCell>
              <TableCell align="right">{row.ten}</TableCell>
              <TableCell align="right">{row.neg}</TableCell>
              <TableCell align="right">{row.pn}</TableCell>
              <TableCell align="right">{row.gn}</TableCell>
              <TableCell align="right">{row.tuh}</TableCell>
              <TableCell align="right">{row.pptuh}</TableCell>
              <TableCell align="right">{row.points}</TableCell>
              <TableCell align="right">{row.pp20}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
